const PEDDLER_HATS = [
  {
    slug: "peddler-black-48",
    name: "Peddler",
    description: "Dispensing wares and surprises",
    rarity: "uncommon",
    slot: "hat",
    statChanges: [
      {
        stat: "blackColor",
        value: 10
      },
      {
        stat: "blackRes",
        value: 5
      }
    ],
    sprite: {
      sheet: "wardrobe/cloth/hat_black",
      frameIndex: 48
    },
    tags: [
      "daily-rotation"
    ],
    shopCategory: "hat"
  },
  {
    slug: "peddler-blue-48",
    name: "Peddler",
    description: "Dispensing wares and surprises",
    rarity: "uncommon",
    slot: "hat",
    statChanges: [
      {
        stat: "blueColor",
        value: 10
      },
      {
        stat: "blueRes",
        value: 5
      }
    ],
    sprite: {
      sheet: "wardrobe/cloth/hat_blue",
      frameIndex: 48
    },
    tags: [
      "daily-rotation"
    ],
    shopCategory: "hat"
  },
  {
    slug: "peddler-orange-48",
    name: "Peddler",
    description: "Dispensing wares and surprises",
    rarity: "uncommon",
    slot: "hat",
    statChanges: [
      {
        stat: "redColor",
        value: 10
      },
      {
        stat: "greenRes",
        value: 5
      }
    ],
    sprite: {
      sheet: "wardrobe/cloth/hat_orange",
      frameIndex: 48
    },
    tags: [
      "daily-rotation"
    ],
    shopCategory: "hat"
  },
  {
    slug: "peddler-pink-48",
    name: "Peddler",
    description: "Dispensing wares and surprises",
    rarity: "uncommon",
    slot: "hat",
    statChanges: [
      {
        stat: "redColor",
        value: 10
      },
      {
        stat: "goldRes",
        value: 5
      }
    ],
    sprite: {
      sheet: "wardrobe/cloth/hat_pink",
      frameIndex: 48
    },
    tags: [
      "daily-rotation"
    ],
    shopCategory: "hat"
  },
  {
    slug: "peddler-purple-48",
    name: "Peddler",
    description: "Dispensing wares and surprises",
    rarity: "uncommon",
    slot: "hat",
    statChanges: [
      {
        stat: "redColor",
        value: 10
      },
      {
        stat: "blueRes",
        value: 5
      }
    ],
    sprite: {
      sheet: "wardrobe/cloth/hat_purple",
      frameIndex: 48
    },
    tags: [
      "daily-rotation"
    ],
    shopCategory: "hat"
  }
];
export {
  PEDDLER_HATS
};
//# sourceMappingURL=data:application/json;base64,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
